import script from "./ManagerCustomerManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerCustomerManagement.vue?vue&type=script&setup=true&lang=js"

import "./ManagerCustomerManagement.vue?vue&type=style&index=0&id=aa42df78&scoped=true&lang=css"
import "./ManagerCustomerManagement.vue?vue&type=style&index=1&id=aa42df78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa42df78"]])

export default __exports__